export default "__VITE_ASSET__DmidwXRS__"